<template>
  <div class="flex h-13">
    <div class="flex pl-6 analytics-first-col-sticky bg-slate-100">
      <div
        class="flex items-center border-b border-l border-r bg-pure-white border-slate-400"
        :class="{ 'rounded-bl': isLast }"
      >
        <div class="flex flex-shrink-0 px-4 w-60">
          <BlTextBody2
            v-if="!item.user_name"
            title="Deleted user"
            text="Deleted user"
            class="italic truncate text-slate-1000"
          />
          <BlTextBody2
            v-else
            :title="item.user_name"
            :text="item.user_name"
            class="truncate text-slate-1000"
          />
        </div>
      </div>
    </div>
    <div
      class="flex items-center flex-shrink-0 w-40 px-4 border-b bg-pure-white border-slate-400"
    >
      <BlTextBody2 :text="item.role === 'admin' ? 'Admin' : 'Therapist'" />
    </div>
    <div
      class="flex items-center flex-shrink-0 w-40 px-4 border-b bg-pure-white border-slate-400"
    >
      <BlTextBody2 :text="item.clients_handled || '-'" />
    </div>
    <!--
      "id": 1,
      "user_name": "Admin 1",
      "role": "admin",
      "clients_handled": 2,
      "total_by_hours": 3.5,
      "client_by_hours": 1.0,
      "therapist_by_hours": 2.5,
      "clinic_or_admin_by_hours": 0
      "total_by_session": 4,
      "client_by_session": 1,
      "therapist_by_session": 3,
      "clinic_or_admin_by_session": 0,
     -->
    <div class="flex border-l bg-pure-white border-slate-400">
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.client_by_hours || '-'" />
      </div>
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.therapist_by_hours || '-'" />
      </div>
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.clinic_or_admin_by_hours || '-'" />
      </div>
    </div>
    <div class="flex border-l border-r bg-pure-white border-slate-400">
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.client_by_session || '-'" />
      </div>
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.therapist_by_session || '-'" />
      </div>
      <div
        class="flex items-center flex-shrink-0 px-4 border-b w-25 border-slate-400"
      >
        <BlTextBody2 :text="item.clinic_or_admin_by_session || '-'" />
      </div>
    </div>
    <div class="flex flex-grow pr-6 analytics-last-col-sticky bg-slate-100">
      <div
        class="flex items-center justify-end flex-grow flex-shrink-0 w-32 px-2 border-b border-r bg-pure-white border-slate-400"
        :class="{ 'rounded-br': isLast }"
      >
        <router-link
          target="_blank"
          :to="{
            name: 'TeamSessionHistory',
            params: {
              user_id: item.id,
              redirect_target: `/analytics/cancellation-overview`,
              redirect_label: 'Cancellation overview analytics'
            }
          }"
          title="View profile"
        >
          <BlInputButton type="outlined" dense label="View profile" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlChip from "../../BlChip.vue";
import BlBubbleCount from "../../BlBubbleCount.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "RowCancellationTherapist",
  components: {
    BlTextSubtitle3,
    BlTextBody2,
    BlChip,
    BlBubbleCount,
    BlInputButton
  },
  props: {
    item: { type: Object, required: true },
    isLast: { type: Boolean, default: false }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    }
  },
  watch: {},
  methods: {
    displayDate(date, format = "DD/MM/YYYY") {
      if (!date) return "-";
      return moment(date).format(format);
    }
  }
};
</script>

<style scoped lang="scss">
.analytics-first-col-sticky {
  position: sticky;
  left: 15rem;
  z-index: 1;
}
.analytics-last-col-sticky {
  position: sticky;
  right: 0rem;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/table/RowCancellationTherapist.vue